// TKP-139 / tasarım s.28 md.3: sistem akış kuralı ekranları yönetici panelinden kalktı; kural motoru ENABLE_SYSTEM_FLOW_RULES
// ile varsayılan KAPALI (TKP-22). Eski adresler panele yönlenir; backend uçları, kural verisi ve store yerinde.
export default {
  routerName: "management",
  routes: [
    { path: "/management/system-flow/create", redirect: "/management/account-workspace-organization" },
    { path: "/management/system-flow/:id", redirect: "/management/account-workspace-organization" },
    { path: "/management/system-flow", redirect: "/management/account-workspace-organization" },
  ],
};
